export default __webpack_public_path__ + "static/terceirizacao-home-3ba2e9fc0aee63599020ef3cb3cd1162.jpg";